import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useParams } from 'react-router-dom';
import chapterApiProvider from '../apiProvider/chapterApi';
import { IMAGE_BASE_URL } from '../network/apiClient';
import { toast } from 'react-toastify';

const TestimonialLayer = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedDoc, setSelectedDoc] = useState('');

    const handleShowDoc = (docUrl) => {
        setSelectedDoc(docUrl);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedDoc('');
    };

    const data = [
        {
            id: 1,
            date: '2025-05-10',
            from: 'Elankathir',
            testimonialTo: 'Prathap',
            chapter: 'GRIP Aram',
            commends: 'Great leadership and vision.',
            doc: 'assets/pdf/testimonial.pdf', // pdf example
        },
        {
            id: 2,
            date: '2025-05-11',
            from: 'Vignesh',
            testimonialTo: 'Surya',
            chapter: 'GRIP Virutcham',
            commends: 'Exceptional collaboration skills.',
            doc: 'assets/images/testimonial/testimonial.jpg',
        },
        {
            id: 3,
            date: '2025-05-12',
            from: 'Naresh',
            testimonialTo: 'Ramesh',
            chapter: 'GRIP Aram',
            commends: 'Very helpful and supportive.',
            doc: 'assets/pdf/testimonial.pdf',
        },
        {
            id: 4,
            date: '2025-05-13',
            from: 'Deepak',
            testimonialTo: 'Abraham',
            chapter: 'GRIP Virutcham',
            commends: 'Always goes above and beyond.',
            doc: 'assets/images/testimonial/testimonial.jpg',
        },
        {
            id: 5,
            date: '2025-05-14',
            from: 'Prakash',
            testimonialTo: 'Adhi',
            chapter: 'GRIP Virutcham',
            commends: 'Inspires the team with dedication.',
            doc: 'assets/pdf/testimonial.pdf',
        },
    ];
    const [chapterMembers, setchapterMembers] = useState([])
    const isImage = (url) => {
        if (!url) return false;
        return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
    };

    const isPdf = (url) => {
        if (!url) return false;
        return /\.(pdf)$/i.test(url);
    };
    const { id } = useParams();
    const fetchChapters = async (id) => {
        try {
            const response = await chapterApiProvider.testimonialSlipListMember(id);
            console.log(response, "responce-chapterApiProvider");
            setchapterMembers(response?.response?.data)
            // You can set the response to state here if needed
        } catch (error) {
            console.error("Error fetching chapters:", error);
            // Handle the error (e.g., show error message to user)
        }
    };
    useEffect(() => {
        fetchChapters(id);
    }, [id]);
    console.log(chapterMembers.chapter, "chapterMembers")
    const handleStatusChange = async (status, recordId) => {
        console.log(status, "status", recordId, "recordId")
        if (!status) return;
        try {
            let input = {
                status: status,
                id: recordId,
                formName: "testimonialslips"
            }
            const response = await chapterApiProvider.changeStatus(input);
            console.log(response, "responce-chapterApiProvider");
            // Handle success
            if (response) {
                toast("status updated successfully")
                fetchChapters(id);
            }
            else {
                toast("failed to update status")
                fetchChapters(id);
            }

        } catch (error) {
            console.error('Error updating status:', error);
            alert('Failed to update status');
        } finally {
        }
    };
    return (
        <div className="col-xxl-12 col-xl-12">
            <div className="card h-100 p-0 radius-12">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <form className="navbar-search">
                            <input
                                type="text"
                                className="bg-base h-40-px w-auto"
                                name="search"
                                placeholder="Search"
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>


                    </div>

                    <div className="d-flex align-items-center flex-wrap gap-3">

                        {/* <select className="form-select form-select-sm w-auto" defaultValue="Select Number">
                            <option value="Select Number" disabled>
                                Select Chapter
                            </option>
                            <option value="10">GRIP Aram</option>
                            <option value="15">GRIP Virutcham</option>
                            <option value="20">GRIP Madhuram</option>
                            <option value="20">GRIP Kireedam</option>
                            <option value="20">GRIP Amudham</option>

                        </select> */}

                        <select className="form-select form-select-sm w-auto" defaultValue="Select Number">
                            <option value="Select Number" >
                                This Week
                            </option>
                            <option value="10">This Month</option>
                            <option value="15">Last Week</option>
                            <option value="20">Last Month</option>
                            <option value="20">This Term</option>


                        </select>

                    </div>
                </div>
                <div className="card-body p-24">
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>From</th>
                                    <th>Testimonial to</th>
                                    <th>Chapter</th>
                                    <th>Commends</th>
                                    <th>Uploaded Doc </th>
                                    <th>Actions </th>
                                </tr>
                            </thead>
                            <tbody>
                                {chapterMembers?.records?.map((item, index) => (
                                    <tr key={item._id}>
                                        <td>{index + 1}.</td>
                                        <td>{new Date(item.createdAt).toLocaleDateString('en-IN')}</td>
                                        <td>
                                            <div className="d-flex flex-column">
                                                <span>{item.fromMember.name}</span>
                                                <small className="text-muted">{item.fromMember.mobile}</small>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex flex-column">
                                                <span>{item.toMember.name}</span>
                                                <small className="text-muted">{item.toMember.mobile}</small>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex flex-column">
                                                <span>{chapterMembers?.chapter?.chapterName}</span>
                                                <small className="text-muted">{chapterMembers?.chapter?.zoneName}</small>
                                            </div>
                                        </td>
                                        <td>{item.comments || '-'}</td>
                                        <td>
                                            {item.images?.length > 0 ? (
                                                <Button
                                                    variant="link"
                                                    onClick={() => handleShowDoc(`${IMAGE_BASE_URL}/${item.images[0].docPath}/${item.images[0].docName}`)}
                                                    className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    title="View Document"
                                                >
                                                    <Icon icon="majesticons:eye" className="icon text-xl" />
                                                </Button>
                                            ) : (
                                                <span className="text-muted">No document</span>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            <select
                                                className="form-select form-select-sm w-auto"
                                                onChange={(e) => handleStatusChange(e.target.value, item._id)}
                                                value={item.status || ""} // Set default to empty or current status
                                            >
                                                <option value="" disabled>Select Action</option>
                                                <option value="active">Active</option>
                                                <option value="decline">decline</option>
                                            </select>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Document Modal */}
                    <Modal show={showModal} onHide={handleClose} size="xl" centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Document Preview</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-center p-0">
                            {isImage(selectedDoc) ? (
                                <img
                                    src={selectedDoc}
                                    alt="Document"
                                    className="img-fluid"
                                    style={{ maxHeight: '70vh', objectFit: 'contain' }}
                                />
                            ) : isPdf(selectedDoc) ? (
                                <div style={{ height: '70vh' }}>
                                    <iframe
                                        src={selectedDoc}
                                        title="PDF Document"
                                        width="100%"
                                        height="100%"
                                        style={{ border: 'none' }}
                                    />
                                </div>
                            ) : (
                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                    <Icon icon="majesticons:file-text-line" className="text-muted mb-3" style={{ fontSize: '3rem' }} />
                                    <h5>Preview not available</h5>
                                    <p className="text-muted">This document type cannot be previewed</p>
                                    <Button
                                        variant="primary"
                                        onClick={() => window.open(selectedDoc, '_blank')}
                                        className="mt-3"
                                    >
                                        Download Document
                                    </Button>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            {selectedDoc && (
                                <Button
                                    variant="primary"
                                    onClick={() => window.open(selectedDoc, '_blank')}
                                >
                                    Open in New Tab
                                </Button>
                            )}
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default TestimonialLayer;
